import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WidgetSettingsForm.html?raw';
import "../../../moreCore/UI/Button/Button";
import { stringify } from "dojo/json";

import { DashboardTypes } from "./../DashboardTypes";

class DashboardWidgetSettingsForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private widgetData: DashboardTypes.WidgetAssignment;
    private widgetUserSettings: DashboardTypes.WidgetSettings;
    private colorInput: HTMLInputElement;

    saveSettings() {
        this.widgetUserSettings.color = this.colorInput.value;
        //this.dashboard.coloration.BackColor.Hex = this.colorInput.value;
        this.widgetData.json_usersettings = stringify(this.widgetUserSettings);

        this._saveSettings();
        this.emit("saving", this.widgetData);
    }

    private _saveSettings() {
        
        let data = { //: OpusEditor.OpusFormData
            widgetID: this.widgetData.ID,
            settings: this.widgetUserSettings
        };

        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__SaveWidgetSettings",
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveDashboarEntityResponse),
            lang.hitch(this, this._onSaveDashboardEntityError),
            false // sync
        );
    }

    private _onSaveDashboarEntityResponse(response) {
        this.emit("saved");
    }
    private _onSaveDashboardEntityError(error: more.requestErrorMessage) {
        alert(error.Message);
    }

    setDirty(isDirty: boolean) {
        this.emit("dirty", isDirty);
    }

    private _onChange_WidgetData() {

        this.widgetUserSettings.color = this.colorInput.value;

        this.setDirty(true);
    }

    

    setData(widget: DashboardTypes.WidgetAssignment) {
        this.widgetData = widget;
        this.widgetUserSettings = !!widget.json_usersettings ? JSON.parse(widget.json_usersettings) : {};
        this.colorInput.value = this.widgetUserSettings.color;
        this.setDirty(false);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DashboardWidgetSettingsForm);
